import { ReactElement } from 'react';

import { useInterpolatedTranslationKey } from '@dreryk/react-common';
import {
   AttachmentsQrCodeUrl,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { ConsentsAndAuthorizationsDocumentScannerForm } from './form/ConsentsAndAuthorizationsDocumentScannerForm';
import { PatientConsentDocumentApproveAttachmentsActionEventInterceptor } from './interceptors/PatientConsentDocumentApproveAttachmentsActionEventInterceptor';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.patientConsentDocumentScannerModal;

type ConsentsAndAuthorizationsDocumentScannerModalProps = {
   readonly onClose: VoidFunction;
   readonly onConfirm: VoidFunction;
   readonly consentDocumentId: number;
   readonly consentDocumentName: string;
   readonly qrCodeUrl: AttachmentsQrCodeUrl;
};

export const ConsentsAndAuthorizationsDocumentScannerModal = (
   props: ConsentsAndAuthorizationsDocumentScannerModalProps
): ReactElement => {
   return (
      <Modal
         title={useInterpolatedTranslationKey(t.title, {
            documentName: props.consentDocumentName,
         })}
         width={ModalWidth.NORMAL}
         testId={'consentsAndAuthorizationsDocumentScanner'}
      >
         <ConsentsAndAuthorizationsDocumentScannerForm
            consentDocumentId={props.consentDocumentId}
            qrCodeUrl={props.qrCodeUrl}
         >
            {({ formState, trigger }) => (
               <>
                  <ValidateFormEventInterceptor trigger={trigger}>
                     <PatientConsentDocumentApproveAttachmentsActionEventInterceptor
                        consentDocumentId={props.consentDocumentId}
                     >
                        <ModalConfirmButton label={t.actions.addScan} onClick={props.onConfirm} />
                     </PatientConsentDocumentApproveAttachmentsActionEventInterceptor>
                  </ValidateFormEventInterceptor>
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </ConsentsAndAuthorizationsDocumentScannerForm>
      </Modal>
   );
};
